(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gs-te-cl-pills"] && !Shopify.designMode) return;
  try {
    
(function () {
  /* Served as static JavaScript: Shopify does not evaluate Liquid inside
     javascript tags, so the section id used to reach the browser as literal
     text, getElementById found nothing, and the early return meant none of
     this ever ran. Roots are found by their data attribute instead, and
     marked so each is only bound once. */
  function teInit() {
  document.querySelectorAll('[data-gs-te-cl-section="pills"]').forEach(function (root) {
  if (root.getAttribute('data-te-bound')) return;
  root.setAttribute('data-te-bound', '1');

  root.addEventListener('click', function (e) {
    var pill = e.target.closest('.gs-te-cl-pill');
    if (!pill) return;
    e.preventDefault();
    var url = pill.getAttribute('data-liquid-url');
    if (!url) return;
    var target = new URL(url, window.location.origin);
    if (target.pathname !== window.location.pathname) {
      window.location = url;
      return;
    }
    if (window.gsTeClLoadCollection) {
      window.gsTeClLoadCollection(url);
    } else if (window.teRcqLoadCollection) {
      window.teRcqLoadCollection(url);
    } else {
      window.location = url;
    }
  });
  });
  }
  /* Section scripts can run before the section's HTML is parsed, which
     left nothing to bind and the buttons inert. Bind once the page is
     ready, and again when the theme editor re-renders a section. */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', teInit);
  } else {
    teInit();
  }
  document.addEventListener('shopify:section:load', teInit);

  // The grid reloads in place, so re-mark which pill matches the URL now
  function syncPills() {
    var cur = new URLSearchParams(window.location.search);
    document.querySelectorAll('[data-gs-te-cl-section="pills"] .gs-te-cl-pill').forEach(function (pill) {
      var u = pill.getAttribute('data-liquid-url');
      if (!u) return;
      var p = new URL(u, window.location.origin).searchParams, keys = 0, hit = 0;
      p.forEach(function (v, k) {
        if (k === 'view' || k === 'chip' || k === 'page' || k === 'sort_by') return;
        keys++;
        if (cur.getAll(k).indexOf(v) > -1) hit++;
      });
      var on = keys ? hit === keys : !Array.from(cur.keys()).some(function (k) { return k.indexOf('filter.') === 0; });
      pill.classList.toggle('is-on', on);
      pill.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }
  document.addEventListener('te-rcq:collection:updated', syncPills);
}());
/* Drag-to-scroll for rows marked data-te-drag-scroll (mouse only; touch
   scrolls natively). The same guarded copy lives in te-rcq-chips,
   te-tcq-brands, gs-te-cl-pills and gs-te-cl-sizebar so any one can bind it; the
   window flag means whichever loads first does, once. */
(function () {
  if (window.__teDragScroll) return;
  window.__teDragScroll = true;
  function bind(el) {
    if (el.__teDrag) return;
    el.__teDrag = true;
    var down = false, moved = false, startX = 0, startLeft = 0;
    el.addEventListener('dragstart', function (e) { e.preventDefault(); });
    el.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      down = true; moved = false; startX = e.clientX; startLeft = el.scrollLeft;
    });
    window.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      if (!moved && Math.abs(dx) > 5) { moved = true; el.classList.add('is-dragging'); }
      if (moved) el.scrollLeft = startLeft - dx;
    });
    window.addEventListener('pointerup', function () {
      if (!down) return;
      down = false;
      el.classList.remove('is-dragging');
    });
    el.addEventListener('click', function (e) {
      if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; }
    }, true);
  }
  function scan() { document.querySelectorAll('[data-te-drag-scroll]').forEach(bind); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', scan); } else { scan(); }
  document.addEventListener('shopify:section:load', scan);
}());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["gs-te-cl-sizebar"] && !Shopify.designMode) return;
  try {
    
(function () {
  /* Served as static JavaScript — Liquid is not evaluated inside javascript
     tags, so the old getElementById lookup on the section id never matched
     and none of this ran. Roots are found by their data attribute. */
  function teInit() {
  document.querySelectorAll('[data-gs-te-cl-section="sizebar"]').forEach(function (root) {
  if (root.getAttribute('data-te-bound')) return;
  root.setAttribute('data-te-bound', '1');

  var STORAGE_KEY = 'gs-te-cl-sizebar';

  function withView(url) {
    var next = new URL(url, window.location.origin);
    return next.pathname + next.search;
  }

  var statusEl = root.querySelector('[data-sb-status]');
  function setLoading(on) {
    root.classList.toggle('is-loading', on);
    if (statusEl) statusEl.textContent = on ? 'Filtering…' : '';
  }
  // Back button can restore this page from cache mid-'Filtering…'
  window.addEventListener('pageshow', function (e) { if (e.persisted) setLoading(false); });
  // The grid reloads in place and announces when it's done
  document.addEventListener('te-rcq:collection:updated', function () {
    setLoading(false);
    var clear = root.querySelector('[data-gs-te-cl-clear-size]');
    if (clear) {
      var q = new URLSearchParams(window.location.search);
      clear.hidden = !(q.get(root.getAttribute('data-size-param')) || q.get(root.getAttribute('data-group-param')));
    }
  });

  function navigate(url) {
    setLoading(true);
    var finalUrl = withView(url);
    var collectionUrl = root.getAttribute('data-collection-url') || '';
    try {
      var params = new URL(finalUrl, window.location.origin).searchParams;
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify({
        size: params.get(root.getAttribute('data-size-param')) || '',
        group: params.get(root.getAttribute('data-group-param')) || '',
        path: collectionUrl || window.location.pathname
      }));
    } catch (e) {}

    // On pages, filter URLs point at the collection — full navigation
    var target = new URL(finalUrl, window.location.origin);
    if (target.pathname !== window.location.pathname) {
      window.location = finalUrl;
      return;
    }

    if (window.gsTeClLoadCollection) {
      window.gsTeClLoadCollection(finalUrl);
    } else if (window.teRcqLoadCollection) {
      window.teRcqLoadCollection(finalUrl);
    } else {
      window.location = finalUrl;
    }
  }

  function setParam(param, value) {
    var base = root.getAttribute('data-collection-url') || window.location.pathname;
    var url = new URL(base, window.location.origin);
    // Keep existing search if already on that collection path
    if (window.location.pathname === url.pathname) {
      url = new URL(window.location.href);
    }
    if (!param) return url.pathname + url.search;
    url.searchParams.delete(param);
    if (value) url.searchParams.append(param, value);
    return url.pathname + url.search;
  }

  root.addEventListener('click', function (e) {
    var btn = e.target.closest('button.gs-te-cl-sb-tab');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    var param = btn.getAttribute('data-param');
    var value = btn.getAttribute('data-value');
    var isOn = btn.classList.contains('is-on');
    navigate(setParam(param, isOn ? '' : value));
  });

  var range = root.querySelector('.gs-te-cl-sb-range');
  if (range) {
    var steps = Array.prototype.map.call(root.querySelectorAll('[data-sb-steps] li'), function (li) {
      return { v: li.getAttribute('data-value'), l: li.getAttribute('data-label') };
    });
    var out = root.querySelector('[data-sb-val]');
    var max = steps.length - 1;
    var timer;
    function pct(i) { return max > 0 ? (i / max) * 100 : 0; }
    var track = range.parentNode;
    function paint() {
      range.style.setProperty('--fill', pct(+range.value) + '%');
      track.style.setProperty('--f', pct(+range.value) / 100);
    }
    var minEl = root.querySelector('[data-sb-min]');
    var maxEl = root.querySelector('[data-sb-max]');
    if (minEl && steps.length) minEl.textContent = steps[0].l;
    if (maxEl && steps.length) maxEl.textContent = steps[max].l;
    paint();
    range.addEventListener('input', function () {
      var s = steps[+range.value];
      if (!s) return;
      range.classList.remove('is-unset');
      range.closest('.gs-te-cl-sb-slider').classList.remove('is-unset');
      out.textContent = s.l;
      range.setAttribute('aria-valuetext', 'Size ' + s.l);
      paint();
    });
    // Apply on release. Arrow keys fire change per step, so wait for a pause.
    range.addEventListener('change', function () {
      clearTimeout(timer);
      timer = setTimeout(function () {
        var s = steps[+range.value];
        if (s) navigate(setParam(range.getAttribute('data-param'), s.v));
      }, 600);
    });
  }

  var clearBtn = root.querySelector('[data-gs-te-cl-clear-size]');
  if (clearBtn) {
    clearBtn.addEventListener('click', function (e) {
      e.preventDefault();
      var url = new URL(clearBtn.href, window.location.origin);
      var sizeParam = root.getAttribute('data-size-param');
      var groupParam = root.getAttribute('data-group-param');
      if (sizeParam) url.searchParams.delete(sizeParam);
      if (groupParam) url.searchParams.delete(groupParam);
      navigate(url.pathname + url.search);
    });
  }
  });
  }
  /* Section scripts can run before the section's HTML is parsed, which
     left nothing to bind and the buttons inert. Bind once the page is
     ready, and again when the theme editor re-renders a section. */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', teInit);
  } else {
    teInit();
  }
  document.addEventListener('shopify:section:load', teInit);
}());
/* Drag-to-scroll for rows marked data-te-drag-scroll (mouse only; touch
   scrolls natively). The same guarded copy lives in te-rcq-chips,
   te-tcq-brands, gs-te-cl-pills and gs-te-cl-sizebar so any one can bind it; the
   window flag means whichever loads first does, once. */
(function () {
  if (window.__teDragScroll) return;
  window.__teDragScroll = true;
  function bind(el) {
    if (el.__teDrag) return;
    el.__teDrag = true;
    var down = false, moved = false, startX = 0, startLeft = 0;
    el.addEventListener('dragstart', function (e) { e.preventDefault(); });
    el.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      down = true; moved = false; startX = e.clientX; startLeft = el.scrollLeft;
    });
    window.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      if (!moved && Math.abs(dx) > 5) { moved = true; el.classList.add('is-dragging'); }
      if (moved) el.scrollLeft = startLeft - dx;
    });
    window.addEventListener('pointerup', function () {
      if (!down) return;
      down = false;
      el.classList.remove('is-dragging');
    });
    el.addEventListener('click', function (e) {
      if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; }
    }, true);
  }
  function scan() { document.querySelectorAll('[data-te-drag-scroll]').forEach(bind); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', scan); } else { scan(); }
  document.addEventListener('shopify:section:load', scan);
}());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["te-pro-player"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';
  var ROOT = document.getElementById('te-ps-root');
  if (!ROOT) return;
  function qs(s, c) { return (c || ROOT).querySelector(s); }
  function qsa(s, c) { return Array.from((c || ROOT).querySelectorAll(s)); }

  function toast(msg) {
    var t = qs('#te-ps-toast'); if (!t) return;
    var m = qs('#te-ps-tmsg'); if (m) m.textContent = msg;
    t.classList.add('te-ps-show'); clearTimeout(t._t);
    t._t = setTimeout(function () { t.classList.remove('te-ps-show'); }, 2600);
  }
  function scrollTo(id) { var e = document.getElementById(id); if (e) e.scrollIntoView({ behavior: 'smooth' }); }
  function addToCart(vid, qty) {
    if (!vid || String(vid).indexOf('VID') > -1) { toast('Connect Shopify variant ID to add to cart'); return; }
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: parseInt(vid, 10), quantity: qty || 1 }) })
      .then(function (r) { return r.json(); })
      .then(function (d) { toast(d.status ? 'Error: ' + (d.description || 'Could not add') : 'Added: ' + d.title); })
      .catch(function () { toast('Something went wrong.'); });
  }
  function addMultiple(items) {
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { return r.json(); })
      .then(function (d) { toast(d.status ? 'Error: ' + (d.description || 'Could not add') : items.length + ' items added to cart'); })
      .catch(function () { toast('Something went wrong.'); });
  }

  /* PDP shoe sizes */
  var pdpSize = null, pdpVid = null;
  qsa('#te-ps-pdp-sizes .te-ps-sz').forEach(function (b) {
    b.addEventListener('click', function () {
      qsa('#te-ps-pdp-sizes .te-ps-sz').forEach(function (x) { x.classList.remove('te-ps-on'); });
      this.classList.add('te-ps-on'); pdpSize = this.dataset.s; pdpVid = this.dataset.vid;
      var l = qs('#te-ps-pdp-sz-lbl'); if (l) l.textContent = '— US ' + pdpSize + ' selected';
      var btn = qs('#te-ps-pdp-shoe-btn');
      if (btn) { btn.textContent = 'Add to Cart — Size ' + pdpSize; btn.style.opacity = '1'; btn.disabled = false; btn.onclick = function () { addToCart(pdpVid, 1); }; }
    });
  });

  /* Bundle builder */
  var bundleState = { racquet: true, strings: true, shoes: false, bag: true };
  var bundleShoeVid = null;
  function getBundlePrice(id) { var e = qs('#te-ps-bi-' + id); return e ? parseFloat(e.dataset.price || 0) : 0; }
  function bundleToggle(id, e) {
    if (e && e.target && e.target.closest('.te-ps-bi-sz-expander')) return;
    bundleState[id] = !bundleState[id];
    var el = qs('#te-ps-bi-' + id), pr = qs('#te-ps-bi-' + id + '-price');
    if (!el) return;
    if (bundleState[id]) { el.classList.add('te-ps-checked'); if (pr) pr.classList.remove('te-ps-dimmed'); }
    else {
      el.classList.remove('te-ps-checked'); if (pr) pr.classList.add('te-ps-dimmed');
      if (id === 'shoes') {
        bundleShoeVid = null;
        qsa('#te-ps-bundle-sz-grid .te-ps-bsz').forEach(function (b) { b.classList.remove('te-ps-on'); });
        var s = qs('#te-ps-bundle-sz-selected'); if (s) { s.style.display = 'none'; s.textContent = ''; }
      }
    }
    updateTotal();
  }
  qsa('#te-ps-bundle-sz-grid .te-ps-bsz').forEach(function (b) {
    b.addEventListener('click', function (e) {
      e.stopPropagation();
      qsa('#te-ps-bundle-sz-grid .te-ps-bsz').forEach(function (x) { x.classList.remove('te-ps-on'); });
      this.classList.add('te-ps-on'); bundleShoeVid = this.dataset.vid;
      var sel = qs('#te-ps-bundle-sz-selected'); if (sel) { sel.textContent = ' — US ' + this.dataset.s; sel.style.display = 'inline'; }
      var n = qs('#te-ps-bi-shoes-note'); if (n) n.textContent = 'Size US ' + this.dataset.s + ' selected';
      var w = qs('#te-ps-shoe-warn'); if (w) w.style.display = 'none';
      updateTotal();
    });
  });
  function updateTotal() {
    var total = 0, count = 0;
    Object.keys(bundleState).forEach(function (id) { if (bundleState[id]) { total += getBundlePrice(id); count++; } });
    var v = qs('#te-ps-bt-val'); if (v) { v.textContent = count > 0 ? '$' + total.toFixed(2) : '$0.00'; v.className = 'te-ps-bt-val' + (count === 0 ? ' te-ps-zero' : ''); }
    var s = qs('#te-ps-bt-summary'); if (s) s.textContent = count === 0 ? 'No items selected' : count === 1 ? '1 item selected' : count + ' items selected';
    var n = qs('#te-ps-bt-note'); if (n) { n.textContent = (bundleState.shoes && !bundleShoeVid) ? 'Select a shoe size above' : ''; n.style.color = '#f5a623'; }
  }
  function addBundle() {
    var ids = Object.keys(bundleState).filter(function (id) { return bundleState[id]; });
    if (!ids.length) { toast('Select at least one item'); return; }
    if (bundleState.shoes && !bundleShoeVid) {
      var el = qs('#te-ps-bi-shoes'); if (el) el.scrollIntoView({ behavior: 'smooth', block: 'center' });
      var w = qs('#te-ps-shoe-warn'); if (w) w.style.display = 'block';
      toast('Please select a shoe size first'); return;
    }
    var items = [];
    ids.forEach(function (id) {
      var el = qs('#te-ps-bi-' + id);
      var vid = id === 'shoes' ? bundleShoeVid : (el ? el.dataset.vid : null);
      if (vid && String(vid).indexOf('VID') === -1) items.push({ id: parseInt(vid, 10), quantity: 1 });
    });
    if (!items.length) { toast('Connect Shopify variant IDs to enable bundle cart'); return; }
    addMultiple(items);
  }

  if (qs('#te-ps-bundle')) updateTotal();
  window.TEPS = { addToCart: addToCart, bundleToggle: bundleToggle, addBundle: addBundle, scrollTo: scrollTo, toast: toast };
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["te-rcq-brands"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.getElementById('te-rcq-brands-{{ section.id }}');
  if (!root) return;

  function buildFilterUrl() {
    var form = document.getElementById('FilterForm');
    if (!form) return window.location.pathname;
    var data = new FormData(form);
    var params = new URLSearchParams();
    for (var pair of data.entries()) {
      if (pair[1]) params.append(pair[0], pair[1]);
    }
    var str = params.toString();
    return window.location.pathname + (str ? '?' + str : '');
  }

  root.querySelectorAll('.te-rcq-brand-card').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var brand = btn.dataset.brand;
      var vendorCbs = document.querySelectorAll('input[name^="filter.p.vendor"]');
      if (vendorCbs.length > 0) {
        vendorCbs.forEach(function (cb) {
          cb.checked = cb.value.toLowerCase() === brand;
        });
        window.location = buildFilterUrl();
      } else {
        var url = btn.dataset.filterUrl;
        if (url) window.location = url;
      }
    });
  });

  var params = new URLSearchParams(window.location.search);
  var activeVendor = params.get('filter.p.vendor');
  if (activeVendor) {
    root.querySelectorAll('.te-rcq-brand-card').forEach(function (btn) {
      if (btn.dataset.brand === activeVendor.toLowerCase()) {
        btn.classList.add('te-rcq-brand-btn--active');
        btn.setAttribute('aria-pressed', 'true');
      }
    });
  }

  var scroll = document.getElementById('te-rcq-brands-scroll-{{ section.id }}');
  var prev   = document.getElementById('te-rcq-brands-prev-{{ section.id }}');
  var next   = document.getElementById('te-rcq-brands-next-{{ section.id }}');
  if (scroll && prev && next) {
    var STEP = 200;
    function updateArrows() {
      prev.disabled = scroll.scrollLeft <= 0;
      next.disabled = scroll.scrollLeft + scroll.clientWidth >= scroll.scrollWidth - 1;
    }
    prev.addEventListener('click', function () { scroll.scrollBy({ left: -STEP, behavior: 'smooth' }); });
    next.addEventListener('click', function () { scroll.scrollBy({ left: STEP, behavior: 'smooth' }); });
    scroll.addEventListener('scroll', updateArrows, { passive: true });
    updateArrows();
  }
}());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["te-rcq-chips"] && !Shopify.designMode) return;
  try {
    
/* Scroll arrows for horizontal rows marked data-te-rail (brand strip, type
   pills). Shared by both sections and bound once. Only the arrows that lead
   somewhere show: "next" while there's more to the right, "prev" once
   scrolled; none at all when everything fits. */
(function () {
  if (window.__teRail) return;
  window.__teRail = true;
  function bind(rail) {
    if (rail.__teRail) return;
    var scroll = rail.querySelector('[data-te-rail-scroll]');
    var nav = rail.querySelector('.te-rcq-rail-nav');
    var prev = rail.querySelector('[data-te-rail-prev]');
    var next = rail.querySelector('[data-te-rail-next]');
    if (!scroll || !nav || !prev || !next) return;
    rail.__teRail = true;
    function update() {
      var atStart = scroll.scrollLeft <= 2;
      var atEnd = scroll.scrollLeft + scroll.clientWidth >= scroll.scrollWidth - 2;
      prev.hidden = atStart;
      next.hidden = atEnd;
      nav.hidden = atStart && atEnd;
    }
    function step() { return Math.max(160, Math.round(scroll.clientWidth * 0.7)); }
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var how = reduce ? 'auto' : 'smooth';
    prev.addEventListener('click', function () { scroll.scrollBy({ left: -step(), behavior: how }); });
    next.addEventListener('click', function () { scroll.scrollBy({ left: step(), behavior: how }); });
    scroll.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    window.addEventListener('load', update);
    update();
  }
  function scan() { document.querySelectorAll('[data-te-rail]').forEach(bind); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', scan); } else { scan(); }
  document.addEventListener('shopify:section:load', scan);
}());
(function () {
  if (window.__teRcqChipsBound) return;
  window.__teRcqChipsBound = true;

  function syncChipActiveStates() {
    var current = new URL(window.location.href);
    var activeChip = current.searchParams.get('chip') || '';

    document.querySelectorAll('.te-rcq-chip').forEach(function (chip) {
      var handle = chip.getAttribute('data-filter') || '';
      var raw = chip.getAttribute('data-liquid-url');
      var active = false;

      if (activeChip) {
        active = activeChip === handle;
      } else if (raw) {
        var chipUrl = new URL(raw, window.location.origin);
        var filterQuery = chip.getAttribute('data-filter-query') || '';
        var samePath = chipUrl.pathname === current.pathname;

        if (samePath) {
          if (!filterQuery) {
            active = !current.search.includes('filter.');
          } else {
            active = current.search.includes(filterQuery)
              || decodeURIComponent(current.search).includes(filterQuery);
          }
        }
      }

      chip.classList.toggle('te-rcq-chip--active', active);
      chip.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  }

  function urlsMatchForChip(current, target) {
    if (current.pathname !== target.pathname) return false;
    var keys = new Set();
    current.searchParams.forEach(function (_, key) { keys.add(key); });
    target.searchParams.forEach(function (_, key) { keys.add(key); });
    keys.delete('sections');
    keys.delete('section_id');
    var match = true;
    keys.forEach(function (key) {
      if (current.searchParams.get(key) !== target.searchParams.get(key)) match = false;
    });
    return match;
  }

  function applyChipFromUrl() {
    var current = new URL(window.location.href);
    var handle = current.searchParams.get('chip');
    if (!handle) {
      syncChipActiveStates();
      return;
    }

    var chip = document.querySelector('.te-rcq-chip[data-filter="' + handle.replace(/"/g, '') + '"]');
    if (!chip) {
      syncChipActiveStates();
      return;
    }

    var raw = chip.getAttribute('data-liquid-url');
    if (!raw) {
      syncChipActiveStates();
      return;
    }

    var target = new URL(raw, window.location.origin);
    var currentView = current.searchParams.get('view');
    if (currentView && !target.searchParams.has('view')) {
      target.searchParams.set('view', currentView);
    }

    if (urlsMatchForChip(current, target)) {
      syncChipActiveStates();
      return;
    }

    loadCollection(target.pathname + target.search);
  }

  async function loadCollection(url) {
    var collectionRoot = document.querySelector('[data-te-rcq-section="collection"]');
    if (!collectionRoot) {
      window.location = url;
      return;
    }

    var sectionEl = collectionRoot.closest('[id^="shopify-section-"]');
    var sectionId = collectionRoot.getAttribute('data-section-id')
      || (sectionEl && sectionEl.id.replace(/^shopify-section-/, ''));

    if (!sectionId || !sectionEl) {
      window.location = url;
      return;
    }

    var fetchUrl = new URL(url, window.location.origin);
    // Keep alternate template if the chip URL omitted it
    var currentView = new URLSearchParams(window.location.search).get('view');
    if (currentView && !fetchUrl.searchParams.has('view')) {
      fetchUrl.searchParams.set('view', currentView);
    }
    fetchUrl.searchParams.set('sections', sectionId);

    collectionRoot.classList.add('is-loading');
    document.querySelectorAll('.te-rcq-chip').forEach(function (c) { c.classList.add('is-loading'); });

    try {
      var res = await fetch(fetchUrl.toString(), {
        headers: { Accept: 'application/json' }
      });
      if (!res.ok) throw new Error('Section fetch failed');
      var data = await res.json();
      var html = data[sectionId];
      if (!html) throw new Error('Missing section HTML');

      var temp = document.createElement('div');
      temp.innerHTML = html;
      var newSection = temp.querySelector('[id^="shopify-section-"]') || temp.firstElementChild;
      if (!newSection) throw new Error('Invalid section markup');

      sectionEl.replaceWith(newSection);

      var nextUrl = new URL(url, window.location.origin);
      if (currentView && !nextUrl.searchParams.has('view')) {
        nextUrl.searchParams.set('view', currentView);
      }
      history.pushState({ teRcqFilter: true }, '', nextUrl.pathname + nextUrl.search);
      syncChipActiveStates();
      document.dispatchEvent(new CustomEvent('te-rcq:collection:updated'));

      var updated = document.querySelector('[data-te-rcq-section="collection"]');
      if (updated) {
        updated.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    } catch (err) {
      window.location = url;
    } finally {
      document.querySelectorAll('.te-rcq-chip.is-loading').forEach(function (c) {
        c.classList.remove('is-loading');
      });
      var root = document.querySelector('[data-te-rcq-section="collection"]');
      if (root) root.classList.remove('is-loading');
    }
  }

  window.teRcqLoadCollection = window.teRcqLoadCollection || loadCollection;

  document.addEventListener('click', function (e) {
    var chip = e.target && e.target.closest ? e.target.closest('.te-rcq-chip') : null;
    if (!chip) return;
    e.preventDefault();
    var url = chip.getAttribute('data-liquid-url');
    if (url && window.teRcqLoadCollection) window.teRcqLoadCollection(url);
  });

  // Prefer collection-section popstate when the grid is present
  if (!document.querySelector('[data-te-rcq-section="collection"]')) {
    window.addEventListener('popstate', function () {
      if (window.teRcqLoadCollection) {
        window.teRcqLoadCollection(window.location.pathname + window.location.search);
      }
    });
  }

  document.addEventListener('te-rcq:collection:updated', syncChipActiveStates);

  // Fade edges on horizontal chip scroll
  document.querySelectorAll('[data-te-rcq-section="chips"]').forEach(function (root) {
    var chipsSection = root.querySelector('.te-rcq-chips');
    var chipsScroll = root.querySelector('.te-rcq-chips-scroll');
    if (!chipsSection || !chipsScroll) return;
    chipsScroll.addEventListener('scroll', function () {
      chipsSection.classList.toggle('te-rcq-chips--scrolled', chipsScroll.scrollLeft > 8);
    }, { passive: true });
  });

  // Deep-link: ?chip=under-250 selects that pill (and loads its filters if needed)
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyChipFromUrl);
  } else {
    applyChipFromUrl();
  }
}());
/* Drag-to-scroll for horizontal rows marked data-te-drag-scroll. Touch
   already scrolls natively; this adds mouse dragging, which the theme
   editor's mobile preview and desktop mice otherwise can't do. Shared by the
   brand strip and type pills and bound once, whichever section loads first. */
(function () {
  if (window.__teDragScroll) return;
  window.__teDragScroll = true;
  function bind(el) {
    if (el.__teDrag) return;
    el.__teDrag = true;
    var down = false, moved = false, startX = 0, startLeft = 0;
    el.addEventListener('dragstart', function (e) { e.preventDefault(); });
    el.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      down = true; moved = false; startX = e.clientX; startLeft = el.scrollLeft;
    });
    window.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      if (!moved && Math.abs(dx) > 5) { moved = true; el.classList.add('is-dragging'); }
      if (moved) el.scrollLeft = startLeft - dx;
    });
    window.addEventListener('pointerup', function () {
      if (!down) return;
      down = false;
      el.classList.remove('is-dragging');
    });
    /* A drag must not also count as a click on the pill or logo under it. */
    el.addEventListener('click', function (e) {
      if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; }
    }, true);
  }
  function scan() { document.querySelectorAll('[data-te-drag-scroll]').forEach(bind); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', scan); } else { scan(); }
  document.addEventListener('shopify:section:load', scan);
}());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["te-rcq-collection"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  var ROOT = document.getElementById('te-rcq-root');
  if (!ROOT) return;

  var SECTION_ID = ROOT.dataset.sectionId || '';

  function qs(sel, ctx)  { return (ctx || ROOT).querySelector(sel); }
  function qsa(sel, ctx) { return Array.from((ctx || ROOT).querySelectorAll(sel)); }

  /* ── Build filter URL from current form state ───────────── */
  function buildFilterUrl() {
    var form = document.getElementById('FilterForm');
    if (!form) return window.location.pathname;
    var data   = new FormData(form);
    var params = new URLSearchParams();
    for (var pair of data.entries()) {
      if (pair[1]) params.append(pair[0], pair[1]);
    }
    var str = params.toString();
    return window.location.pathname + (str ? '?' + str : '');
  }

  /* ── Toggle one string_type2 value in/out of the current URL ─
     Preserves all other active filters and any already-selected
     string types, enabling multi-select custom chips. */
  function toggleStringType(value) {
    var params = new URLSearchParams(window.location.search);
    var key    = 'filter.p.m.custom.string_type2';
    var existing = params.getAll(key);
    var idx = existing.indexOf(value);
    params.delete(key);
    if (idx === -1) existing.push(value);
    else existing.splice(idx, 1);
    existing.forEach(function (v) { params.append(key, v); });
    var str = params.toString();
    return window.location.pathname + (str ? '?' + str : '');
  }

  /* ── AJAX navigation via Section Rendering API ───────────── */
  var fetchCtrl = null;

  function navigateFetch(url, skipPush) {
    if (fetchCtrl) fetchCtrl.abort();
    fetchCtrl = new AbortController();

    var gridMain = qs('.te-rcq-grid-main');
    if (gridMain) {
      gridMain.style.opacity      = '0.4';
      gridMain.style.pointerEvents = 'none';
      gridMain.style.transition   = 'opacity .15s';
    }

    var sep      = url.indexOf('?') !== -1 ? '&' : '?';
    var fetchUrl = SECTION_ID ? url + sep + 'sections=' + encodeURIComponent(SECTION_ID) : url;

    fetch(fetchUrl, { signal: fetchCtrl.signal })
      .then(function (r) { return SECTION_ID ? r.json() : r.text(); })
      .then(function (payload) {
        var html = SECTION_ID ? (payload[SECTION_ID] || Object.values(payload)[0] || '') : payload;
        var doc  = new DOMParser().parseFromString(html, 'text/html');

        var newGrid = doc.querySelector('#te-rcq-grid');
        var oldGrid = qs('#te-rcq-grid');
        if (newGrid && oldGrid) oldGrid.replaceWith(newGrid);

        var newCount = doc.querySelector('.te-rcq-toolbar-count');
        var oldCount = qs('.te-rcq-toolbar-count');
        if (newCount && oldCount) oldCount.textContent = newCount.textContent;

        var newPag = doc.querySelector('.te-rcq-pagination');
        var oldPag = qs('.te-rcq-pagination');
        if (oldPag) oldPag.remove();
        if (newPag) { var g = qs('#te-rcq-grid'); if (g) g.after(newPag); }

        var newSidebar = doc.querySelector('#te-rcq-filters');
        var oldSidebar = qs('#te-rcq-filters');
        if (newSidebar && oldSidebar) oldSidebar.replaceWith(newSidebar);

        if (!skipPush) history.pushState({}, '', url);

        syncChips();
        syncBrandStrip();

        if (gridMain) {
          gridMain.style.opacity      = '1';
          gridMain.style.pointerEvents = '';
        }

        initReveal(qs('#te-rcq-grid'));
        fetchCtrl = null;
      })
      .catch(function (err) {
        if (err.name !== 'AbortError') window.location = url;
      });
  }

  /* ── Sync chip highlight from URL ───────────────────────── */
  /* Handles three chip families:
     - Built-in racquet chips (data-filter: all/under-250/on-sale/demo/pro-worn)
     - Custom filter chips (data-filter: custom / custom-all), matched by the
       filter.p.m.custom.string_type2 param against data-filter-value.
     - Plain anchor chips (no data-filter) are left as rendered. */
  function syncChips() {
    var params      = new URLSearchParams(window.location.search);
    var tag         = (params.get('filter.p.tag') || '').toLowerCase();
    var stringTypes = params.getAll('filter.p.m.custom.string_type2');

    qsa('.te-rcq-chip').forEach(function (chip) {
      var f = chip.dataset.filter;
      if (!f) return;

      var active = false;
      if      (f === 'custom-all') active = stringTypes.length === 0;
      else if (f === 'custom')     active = stringTypes.indexOf(chip.dataset.filterValue || '') !== -1;
      else if (f === 'all')        active = !params.has('filter.p.tag') && !params.has('filter.v.price.lte') && !params.has('filter.p.vendor');
      else if (f === 'beginner')   active = tag === 'beginner';
      else if (f === 'under-250')  active = params.has('filter.v.price.lte');
      else if (f === 'on-sale')    active = tag === 'sale';
      else if (f === 'demo')       active = tag === 'demo available';
      else if (f === 'pro-worn')   active = tag === 'pro worn';

      chip.classList.toggle('te-rcq-chip--active', active);
      chip.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  }

  /* ── Sync brand strip highlight from URL ────────────────── */
  function syncBrandStrip() {
    var params       = new URLSearchParams(window.location.search);
    var activeVendor = (params.get('filter.p.vendor') || '').toLowerCase();

    qsa('.te-rcq-brand-card').forEach(function (btn) {
      var active = btn.dataset.brand === activeVendor;
      btn.classList.toggle('te-rcq-brand-btn--active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      if (active) showBrandCta(btn);
    });

    if (!activeVendor) hideBrandCta();
  }

  function showBrandCta(btn) {
    var label   = btn.dataset.label || btn.dataset.brand;
    var ctaEl   = qs('#te-rcq-brand-cta');
    var ctaMsg  = qs('#te-rcq-brand-cta-msg');
    var ctaLink = qs('#te-rcq-brand-cta-link');
    if (!ctaEl) return;
    if (ctaMsg)  ctaMsg.textContent = 'Showing ' + label + ' racquets';
    if (ctaLink) {
      ctaLink.textContent = 'View all ' + label + ' Racquets →';
      ctaLink.href = window.location.pathname + '?filter.p.vendor=' + encodeURIComponent(label);
    }
    ctaEl.classList.add('te-rcq-brand-cta--visible');
  }

  function hideBrandCta() {
    var ctaEl = qs('#te-rcq-brand-cta');
    if (ctaEl) ctaEl.classList.remove('te-rcq-brand-cta--visible');
  }

  function handleBrandClick(btn) {
    var label    = btn.dataset.label;
    var isActive = btn.classList.contains('te-rcq-brand-btn--active');

    var allCbs  = qsa('input.te-rcq-filter-input[type="checkbox"]');
    var matched = null;
    for (var i = 0; i < allCbs.length; i++) {
      if (allCbs[i].value.toLowerCase() === label.toLowerCase()) { matched = allCbs[i]; break; }
    }

    var url;
    if (matched) {
      allCbs.forEach(function (cb) { if (cb.name === matched.name) cb.checked = false; });
      if (!isActive) matched.checked = true;
      url = buildFilterUrl();
    } else {
      url = isActive
        ? window.location.pathname
        : window.location.pathname + '?filter.p.vendor=' + encodeURIComponent(label);
    }
    navigateFetch(url);
  }

  function openFilters() {
    var s = qs('#te-rcq-filters'), b = qs('#te-rcq-filter-backdrop'), t = qs('#te-rcq-filter-btn');
    if (s) s.classList.add('te-rcq-filters--open');
    if (b) b.classList.add('te-rcq-filter-backdrop--open');
    if (t) t.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }
  function closeFilters() {
    var s = qs('#te-rcq-filters'), b = qs('#te-rcq-filter-backdrop'), t = qs('#te-rcq-filter-btn');
    if (s) s.classList.remove('te-rcq-filters--open');
    if (b) b.classList.remove('te-rcq-filter-backdrop--open');
    if (t) t.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }

  /* ── Event delegation (survives sidebar swaps) ──────────── */
  ROOT.addEventListener('click', function (e) {
    if (e.target.closest('.te-rcq-brand-card'))      { handleBrandClick(e.target.closest('.te-rcq-brand-card')); return; }
    if (e.target.closest('#te-rcq-brand-cta-clear')) { navigateFetch(window.location.pathname); return; }
    if (e.target.closest('.te-rcq-price-apply'))     { navigateFetch(buildFilterUrl()); return; }
    if (e.target.closest('.te-rcq-filters-clear'))   { e.preventDefault(); navigateFetch(e.target.closest('.te-rcq-filters-clear').href); return; }
    if (e.target.closest('.te-rcq-page-link'))       { e.preventDefault(); navigateFetch(e.target.closest('.te-rcq-page-link').href); return; }
    if (e.target.closest('#te-rcq-filter-backdrop')) { closeFilters(); return; }

    /* Custom string-type chips multi-select: toggle this value in/out of the
       existing string_type2 params, preserving any other active filters.
       The "All" reset chip (custom-all) and built-in chips still use
       data-liquid-url for single-value navigation. */
    var chip = e.target.closest('.te-rcq-chip');
    if (chip && chip.dataset.filter === 'custom') {
      navigateFetch(toggleStringType(chip.dataset.filterValue || ''));
      return;
    }
    if (chip && chip.dataset.liquidUrl) { navigateFetch(chip.dataset.liquidUrl); return; }
  });

  ROOT.addEventListener('change', function (e) {
    if (e.target.matches('input.te-rcq-filter-input')) { navigateFetch(buildFilterUrl()); return; }
    if (e.target.matches('.te-rcq-sort'))              { navigateFetch(buildFilterUrl()); return; }
  });

  var filterBtn = qs('#te-rcq-filter-btn');
  if (filterBtn) {
    filterBtn.addEventListener('click', function () {
      var s = qs('#te-rcq-filters');
      if (s && s.classList.contains('te-rcq-filters--open')) closeFilters(); else openFilters();
    });
  }
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeFilters(); });

  function initReveal(container) {
    if (!window.IntersectionObserver) return;
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.style.opacity   = '1';
          entry.target.style.transform = 'translateY(0)';
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.05 });
    var scope = container || ROOT;
    var selector = container ? '.te-rcq-pc, .te-rcq-banner' : '.te-rcq-pc, .te-rcq-banner, .te-rcq-tile, .te-rcq-pro-card';
    qsa(selector, scope).forEach(function (el) {
      el.style.opacity    = '0';
      el.style.transform  = 'translateY(16px)';
      el.style.transition = 'opacity .35s ease, transform .35s ease';
      observer.observe(el);
    });
  }

  function initBrandArrows() {
    var scroll = qs('#te-rcq-brands-scroll');
    var prev   = qs('#te-rcq-brands-prev');
    var next   = qs('#te-rcq-brands-next');
    if (!scroll || !prev || !next) return;
    var STEP = 200;
    function updateArrows() {
      prev.disabled = scroll.scrollLeft <= 0;
      next.disabled = scroll.scrollLeft + scroll.clientWidth >= scroll.scrollWidth - 1;
    }
    prev.addEventListener('click', function () { scroll.scrollBy({ left: -STEP, behavior: 'smooth' }); });
    next.addEventListener('click', function () { scroll.scrollBy({ left:  STEP, behavior: 'smooth' }); });
    scroll.addEventListener('scroll', updateArrows, { passive: true });
    updateArrows();
  }

  function initChipsScroll() {
    var sec = qs('.te-rcq-chips'), scroll = qs('.te-rcq-chips-scroll');
    if (!sec || !scroll) return;
    scroll.addEventListener('scroll', function () {
      sec.classList.toggle('te-rcq-chips--scrolled', scroll.scrollLeft > 8);
    }, { passive: true });
  }

  window.addEventListener('popstate', function () {
    navigateFetch(window.location.href, true);
  });

  document.addEventListener('DOMContentLoaded', function () {
    syncChips();
    syncBrandStrip();
    initReveal();
    initBrandArrows();
    initChipsScroll();
  });
}());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["te-rcq-collections"] && !Shopify.designMode) return;
  try {
    
/* Colour swatches on product cards: hovering or focusing a dot shows that
   colour's photo on the card. Delegated, so it works after AJAX filtering. */
(function () {
  if (window.__teRcqSwatches) return;
  window.__teRcqSwatches = true;
  function show(sw) {
    var url = sw.getAttribute('data-te-sw-img');
    var card = sw.closest('.te-rcq-pc');
    if (!url || !card) return;
    var img = card.querySelector('.te-rcq-pc-img-actual:not(.te-rcq-pc-img-alt)');
    if (!img) return;
    if (!img.hasAttribute('data-te-orig')) img.setAttribute('data-te-orig', img.getAttribute('src') || '');
    img.removeAttribute('srcset');
    img.src = url;
    card.classList.add('te-rcq-pc-sw-active');
    var all = sw.parentNode.querySelectorAll('.te-rcq-pc-sw');
    for (var i = 0; i < all.length; i++) all[i].classList.toggle('is-on', all[i] === sw);
  }
  document.addEventListener('mouseover', function (e) {
    var sw = e.target.closest && e.target.closest('[data-te-sw-img]');
    if (sw) show(sw);
  });
  document.addEventListener('focusin', function (e) {
    var sw = e.target.closest && e.target.closest('[data-te-sw-img]');
    if (sw) show(sw);
  });
}());
(function () {
  if (window.__teRcqCollectionBound) return;
  window.__teRcqCollectionBound = true;

  var loadTimer = null;
  var loadSeq = 0;

  function getRoot() {
    return document.querySelector('[data-te-rcq-section="collection"]');
  }

  function ensureViewParam(urlLike) {
    var url = new URL(urlLike, window.location.origin);
    var currentView = new URLSearchParams(window.location.search).get('view');
    if (currentView && !url.searchParams.has('view')) {
      url.searchParams.set('view', currentView);
    }
    // Drop pagination when filters change
    url.searchParams.delete('page');
    return url;
  }

  function stripChip(urlLike) {
    var url = ensureViewParam(urlLike);
    url.searchParams.delete('chip');
    return url.pathname + url.search;
  }

  function buildFilterUrl() {
    var form = document.querySelector('[data-te-rcq-filter-form]');
    var root = getRoot();
    var path = (root && root.getAttribute('data-collection-url')) || window.location.pathname;
    var params = new URLSearchParams();

    if (form) {
      var data = new FormData(form);
      data.forEach(function (value, key) {
        if (value !== '' && value != null) params.append(key, value);
      });
    }

    var sort = document.querySelector('[data-te-rcq-sort]');
    if (sort && sort.value && !params.has('sort_by')) {
      params.set('sort_by', sort.value);
    }

    var currentView = new URLSearchParams(window.location.search).get('view');
    if (currentView && !params.has('view')) params.set('view', currentView);

    params.delete('page');
    var str = params.toString();
    return path + (str ? '?' + str : '');
  }

  function clearCollectionUrl() {
    var root = getRoot();
    var path = (root && root.getAttribute('data-collection-url')) || window.location.pathname;
    var params = new URLSearchParams();
    var currentView = new URLSearchParams(window.location.search).get('view');
    if (currentView) params.set('view', currentView);
    var str = params.toString();
    return path + (str ? '?' + str : '');
  }

  function withView(urlLike) {
    var url = ensureViewParam(urlLike);
    return url.pathname + url.search;
  }

  function syncPopularActiveStates() {
    var current = new URL(window.location.href);
    var activeChip = current.searchParams.get('chip') || '';
    var nodes = document.querySelectorAll('.te-rcq-popular-input, .te-rcq-popular-pill');

    nodes.forEach(function (el) {
      var handle = el.getAttribute('data-filter') || '';
      var filterQuery = el.getAttribute('data-filter-query') || '';
      var active = false;

      // Only explicit selection — never treat blank chips as “always on”
      if (activeChip) {
        active = activeChip === handle;
      } else if (filterQuery) {
        active = current.search.includes(filterQuery)
          || decodeURIComponent(current.search).includes(filterQuery);
      }

      if (el.classList.contains('te-rcq-popular-input')) {
        el.checked = active;
      } else {
        el.classList.toggle('te-rcq-popular-pill--active', active);
        el.setAttribute('aria-pressed', active ? 'true' : 'false');
      }
    });
  }

  async function fetchSectionHtml(url, sectionId) {
    var fetchUrl = ensureViewParam(url);
    fetchUrl.searchParams.set('sections', sectionId);

    var res = await fetch(fetchUrl.toString(), {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin'
    });

    if (res.ok) {
      var contentType = res.headers.get('content-type') || '';
      if (contentType.indexOf('application/json') !== -1) {
        var data = await res.json();
        if (data && data[sectionId]) return data[sectionId];
      }
    }

    // Fallback: section_id returns raw HTML
    var fallbackUrl = ensureViewParam(url);
    fallbackUrl.searchParams.delete('sections');
    fallbackUrl.searchParams.set('section_id', sectionId);
    res = await fetch(fallbackUrl.toString(), { credentials: 'same-origin' });
    if (!res.ok) throw new Error('Section fetch failed');
    return await res.text();
  }

  async function loadCollection(url, options) {
    options = options || {};
    var collectionRoot = getRoot();
    if (!collectionRoot) {
      window.location = withView(url);
      return;
    }

    var sectionEl = collectionRoot.closest('[id^="shopify-section-"]');
    var sectionId = collectionRoot.getAttribute('data-section-id')
      || (sectionEl && sectionEl.id.replace(/^shopify-section-/, ''));

    if (!sectionId || !sectionEl) {
      window.location = withView(url);
      return;
    }

    var keepFiltersOpen = options.keepFiltersOpen
      || !!(collectionRoot.querySelector('.te-rcq-filters.te-rcq-filters--open'));

    var seq = ++loadSeq;
    collectionRoot.classList.add('is-loading');
    document.querySelectorAll('.te-rcq-popular-pill, .te-rcq-chip, .te-rcq-popular-input').forEach(function (c) {
      c.classList.add('is-loading');
    });

    try {
      var html = await fetchSectionHtml(url, sectionId);
      if (seq !== loadSeq) return;
      if (!html) throw new Error('Missing section HTML');

      var temp = document.createElement('div');
      temp.innerHTML = html;
      var newSection = temp.querySelector('[id^="shopify-section-"]')
        || temp.querySelector('[data-te-rcq-section="collection"]')
        || temp.firstElementChild;
      if (!newSection) throw new Error('Invalid section markup');

      // If API returned inner root only, keep outer shopify-section wrapper
      if (newSection.getAttribute && newSection.getAttribute('data-te-rcq-section') === 'collection') {
        sectionEl.innerHTML = newSection.outerHTML;
      } else {
        sectionEl.replaceWith(newSection);
      }

      var nextUrl = ensureViewParam(url);
      // Back/forward already moved the history; only new filter changes add an entry
      if (!options.fromHistory) {
        history.pushState({ teRcqFilter: true }, '', nextUrl.pathname + nextUrl.search);
      }
      syncPopularActiveStates();
      document.dispatchEvent(new CustomEvent('te-rcq:collection:updated'));

      if (keepFiltersOpen) {
        var updated = getRoot();
        if (updated) {
          var sidebar = updated.querySelector('.te-rcq-filters');
          var backdrop = updated.querySelector('.te-rcq-filter-backdrop');
          var toggleBtn = updated.querySelector('.te-rcq-filter-toggle');
          if (sidebar) sidebar.classList.add('te-rcq-filters--open');
          if (backdrop) backdrop.classList.add('te-rcq-filter-backdrop--open');
          if (toggleBtn) toggleBtn.setAttribute('aria-expanded', 'true');
          document.body.style.overflow = 'hidden';
        }
      }
    } catch (err) {
      if (seq !== loadSeq) return;
      window.location = withView(url);
    } finally {
      document.querySelectorAll('.te-rcq-popular-pill.is-loading, .te-rcq-chip.is-loading, .te-rcq-popular-input.is-loading').forEach(function (c) {
        c.classList.remove('is-loading');
      });
      var root = getRoot();
      if (root) root.classList.remove('is-loading');
    }
  }

  function queueLoad(url, options) {
    clearTimeout(loadTimer);
    loadTimer = setTimeout(function () {
      loadCollection(url, options);
    }, 120);
  }

  window.teRcqLoadCollection = loadCollection;

  function animateCards(root) {
    if (!root || !window.IntersectionObserver) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var el = entry.target;
          el.style.opacity = '1';
          el.style.transform = 'translateY(0)';
          observer.unobserve(el);
          // Hand transform back to the stylesheet so the hover lift works
          setTimeout(function () { el.style.transform = ''; el.style.transition = ''; }, 400);
        }
      });
    }, { threshold: 0.08 });
    root.querySelectorAll('.te-rcq-pc, .te-rcq-banner').forEach(function (el) {
      el.style.opacity = '0';
      el.style.transform = 'translateY(16px)';
      el.style.transition = 'opacity .35s ease, transform .35s ease';
      observer.observe(el);
    });
  }

  function bindMobileFilters(root) {
    if (!root) return;
    var toggleBtn = root.querySelector('.te-rcq-filter-toggle');
    var sidebar = root.querySelector('.te-rcq-filters');
    var backdrop = root.querySelector('.te-rcq-filter-backdrop');
    if (!toggleBtn || !sidebar) return;

    function openFilters() {
      sidebar.classList.add('te-rcq-filters--open');
      if (backdrop) backdrop.classList.add('te-rcq-filter-backdrop--open');
      toggleBtn.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      var closeBtn = sidebar.querySelector('[data-te-rcq-filters-close]');
      if (closeBtn) closeBtn.focus();
    }
    function closeFilters() {
      sidebar.classList.remove('te-rcq-filters--open');
      if (backdrop) backdrop.classList.remove('te-rcq-filter-backdrop--open');
      toggleBtn.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      toggleBtn.focus();
    }
    var closeEl = sidebar.querySelector('[data-te-rcq-filters-close]');
    if (closeEl) closeEl.addEventListener('click', closeFilters);

    toggleBtn.addEventListener('click', function () {
      sidebar.classList.contains('te-rcq-filters--open') ? closeFilters() : openFilters();
    });
    if (backdrop) backdrop.addEventListener('click', closeFilters);
  }

  function initCollection() {
    var root = getRoot();
    if (!root) return;
    bindMobileFilters(root);
    animateCards(root);
    syncPopularActiveStates();
  }

  document.addEventListener('submit', function (e) {
    var form = e.target && e.target.closest ? e.target.closest('[data-te-rcq-filter-form]') : null;
    if (!form) return;
    e.preventDefault();
    queueLoad(stripChip(buildFilterUrl()), { keepFiltersOpen: true });
  });

  document.addEventListener('change', function (e) {
    if (!e.target || !e.target.classList) return;

    if (e.target.classList.contains('te-rcq-popular-input')) {
      var popularUrl = e.target.checked
        ? e.target.getAttribute('data-liquid-url')
        : (e.target.getAttribute('data-url-to-remove') || clearCollectionUrl());
      if (popularUrl) queueLoad(withView(popularUrl));
      return;
    }

    if (e.target.matches && e.target.matches('[data-te-rcq-sort]')) {
      queueLoad(stripChip(buildFilterUrl()));
      return;
    }

    if (!e.target.classList.contains('te-rcq-filter-input')) return;

    var nextUrl = e.target.checked
      ? e.target.getAttribute('data-url-to-add')
      : e.target.getAttribute('data-url-to-remove');

    queueLoad(stripChip(nextUrl || buildFilterUrl()), { keepFiltersOpen: true });
  });

  document.addEventListener('click', function (e) {
    var clearBtn = e.target && e.target.closest ? e.target.closest('[data-te-rcq-clear-all]') : null;
    if (clearBtn) {
      e.preventDefault();
      queueLoad(clearBtn.getAttribute('href') || clearCollectionUrl());
      return;
    }

    var priceApply = e.target && e.target.closest ? e.target.closest('[data-te-rcq-price-apply]') : null;
    if (priceApply) {
      e.preventDefault();
      queueLoad(stripChip(buildFilterUrl()), { keepFiltersOpen: true });
      return;
    }

    var pill = e.target && e.target.closest ? e.target.closest('.te-rcq-popular-pill') : null;
    if (!pill) return;
    e.preventDefault();
    var pillActive = pill.classList.contains('te-rcq-popular-pill--active');
    var pillUrl = pillActive
      ? (pill.getAttribute('data-url-to-remove') || clearCollectionUrl())
      : pill.getAttribute('data-liquid-url');
    if (pillUrl) queueLoad(withView(pillUrl));
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && e.target && e.target.classList && e.target.classList.contains('te-rcq-price-input')) {
      e.preventDefault();
      queueLoad(stripChip(buildFilterUrl()), { keepFiltersOpen: true });
      return;
    }
    if (e.key !== 'Escape') return;
    var root = getRoot();
    if (!root) return;
    var sidebar = root.querySelector('.te-rcq-filters');
    var backdrop = root.querySelector('.te-rcq-filter-backdrop');
    var toggleBtn = root.querySelector('.te-rcq-filter-toggle');
    if (sidebar) sidebar.classList.remove('te-rcq-filters--open');
    if (backdrop) backdrop.classList.remove('te-rcq-filter-backdrop--open');
    if (toggleBtn) toggleBtn.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  });

  window.addEventListener('popstate', function () {
    loadCollection(window.location.pathname + window.location.search, { fromHistory: true });
  });

  document.addEventListener('te-rcq:collection:updated', initCollection);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCollection);
  } else {
    initCollection();
  }

  window.teRcqBuildFilterUrl = buildFilterUrl;
}());

/* Touch screens have no hover, so the first tap on a card's photo reveals
   Quick view instead of opening the product. A second tap on the photo
   opens the product as normal. Tapping anywhere else closes it. */
(function () {
  if (window.__teRcqQvTouch) return;
  window.__teRcqQvTouch = true;
  var mq = window.matchMedia ? window.matchMedia('(hover: none), (pointer: coarse)') : null;
  function isTouch() { return mq ? mq.matches : ('ontouchstart' in window); }
  function closeAll(except) {
    document.querySelectorAll('.te-rcq-pc.is-qv-open').forEach(function (c) {
      if (c !== except) c.classList.remove('is-qv-open');
    });
  }
  function inPhoto(card, e) {
    var img = card.querySelector('.te-rcq-pc-img');
    if (!img || e.clientX == null) return false;
    var r = img.getBoundingClientRect();
    return e.clientX >= r.left && e.clientX <= r.right && e.clientY >= r.top && e.clientY <= r.bottom;
  }
  document.addEventListener('click', function (e) {
    if (!isTouch()) return;
    var t = e.target;
    var card = t.closest && t.closest('.te-rcq-pc');
    if (!card) { closeAll(null); return; }
    if (t.closest('.te-rcq-pc-qv') || t.closest('.te-rcq-pc-swatches')) return;
    if (!card.querySelector('.te-rcq-pc-qv')) return;
    if (!inPhoto(card, e)) { closeAll(null); return; }
    if (card.classList.contains('is-qv-open')) return;
    e.preventDefault();
    e.stopPropagation();
    closeAll(card);
    card.classList.add('is-qv-open');
  }, true);
}());

/* Quick view. Card buttons carry data-te-qv="<handle>"; one <dialog> is
   reused. Product data comes from Shopify's /products/<handle>.js, and Add
   to cart posts to /cart/add.js, so it works with any theme cart. */
(function () {
  if (window.__teRcqQv) return;
  window.__teRcqQv = true;
  var dlg = null, product = null, sel = [], imgIdx = 0;
  function root() { return document.querySelector('[data-te-rcq-section="collection"]'); }
  function money(cents) {
    var r = root(), cur = (r && r.getAttribute('data-te-qv-currency')) || 'USD', loc = (r && r.getAttribute('data-te-qv-locale')) || 'en';
    try { return new Intl.NumberFormat(loc, { style: 'currency', currency: cur }).format(cents / 100); }
    catch (e) { return '$' + (cents / 100).toFixed(2); }
  }
  function sized(src, w) { return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }
  function esc(t) { var d = document.createElement('div'); d.textContent = t == null ? '' : String(t); return d.innerHTML.replace(/"/g, '&quot;'); }
  function noProto(u) { return String(u || '').replace(/^https?:/, ''); }
  function ensure() {
    if (dlg) return dlg;
    dlg = document.createElement('dialog');
    dlg.className = 'te-rcq-qv';
    dlg.setAttribute('aria-label', 'Quick view');
    dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
    document.body.appendChild(dlg);
    return dlg;
  }
  function variant() {
    if (!product) return null;
    return product.variants.find(function (v) {
      return (v.options || []).every(function (o, i) { return o === sel[i]; });
    }) || null;
  }
  function optName(o) { return typeof o === 'string' ? o : o.name; }
  function render() {
    var v = variant(), imgs = product.images || [];
    var html = '<div class="te-rcq-qv-in"><button type="button" class="te-rcq-qv-x" aria-label="Close">&times;</button><div>';
    html += '<div class="te-rcq-qv-main">' + (imgs[imgIdx] ? '<img src="' + esc(sized(imgs[imgIdx], 900)) + '" alt="' + esc(product.title) + '">' : '') + '</div>';
    if (imgs.length > 1) {
      html += '<div class="te-rcq-qv-thumbs">' + imgs.slice(0, 10).map(function (src, i) {
        return '<button type="button" data-qv-img="' + i + '" class="' + (i === imgIdx ? 'is-on' : '') + '" aria-label="Photo ' + (i + 1) + '"><img src="' + esc(sized(src, 140)) + '" alt=""></button>';
      }).join('') + '</div>';
    }
    html += '</div><div><p class="te-rcq-qv-vendor">' + esc(product.vendor) + '</p><h2 class="te-rcq-qv-title">' + esc(product.title) + '</h2>';
    var price = v ? v.price : product.price, was = v ? v.compare_at_price : product.compare_at_price;
    html += '<p class="te-rcq-qv-price">' + money(price) + (was && was > price ? '<s>' + money(was) + '</s>' : '') + '</p>';
    (product.options || []).forEach(function (o, oi) {
      var name = optName(o), vals = typeof o === 'string' ? [] : (o.values || []);
      if (name === 'Title' && vals.length <= 1) return;
      html += '<div class="te-rcq-qv-opt"><p>' + esc(name) + (sel[oi] ? ': <span style="text-transform:none;letter-spacing:0;font-weight:600">' + esc(sel[oi]) + '</span>' : '') + '</p><div class="te-rcq-qv-vals">';
      vals.forEach(function (val) {
        var trial = sel.slice(); trial[oi] = val;
        var match = product.variants.find(function (x) {
          return x.available && x.options.every(function (y, k) { return trial[k] == null || y === trial[k]; });
        });
        var out = !match;
        html += '<button type="button" data-qv-opt="' + oi + '" data-qv-val="' + esc(val) + '" class="' + (sel[oi] === val ? 'is-on ' : '') + (out ? 'is-out' : '') + '">' + esc(val) + '</button>';
      });
      html += '</div></div>';
    });
    var can = v && v.available;
    html += '<button type="button" class="te-rcq-qv-add" ' + (can ? '' : 'disabled') + '>' + (v ? (v.available ? 'Add to cart' : 'Sold out') : 'Choose a size') + '</button>';
    html += '<p class="te-rcq-qv-msg" aria-live="polite"></p><a class="te-rcq-qv-full" href="/products/' + esc(product.handle) + '">View full details &rarr;</a></div></div>';
    dlg.innerHTML = html;
  }
  function open(handle) {
    ensure();
    dlg.innerHTML = '<div class="te-rcq-qv-load">Loading…</div>';
    if (!dlg.open) dlg.showModal();
    fetch('/products/' + encodeURIComponent(handle) + '.js').then(function (r) { if (!r.ok) throw 0; return r.json(); }).then(function (p) {
      product = p; imgIdx = 0;
      var first = p.variants.find(function (v) { return v.available; }) || p.variants[0];
      // Preselect every option except a multi-value last one (size): the shopper picks that
      sel = (first.options || []).slice();
      var opts = p.options || [];
      if (p.variants.length > 1 && opts.length) {
        var last = opts[opts.length - 1], vals = typeof last === 'string' ? [] : (last.values || []);
        if (vals.length > 1) sel[opts.length - 1] = null;
      }
      render();
    }).catch(function () { dlg.innerHTML = '<div class="te-rcq-qv-load">Couldn’t load this product. <a href="/products/' + esc(handle) + '">Open it</a></div>'; });
  }
  document.addEventListener('click', function (e) {
    var qv = e.target.closest && e.target.closest('[data-te-qv]');
    if (qv) { e.preventDefault(); open(qv.getAttribute('data-te-qv')); return; }
    if (!dlg || !dlg.contains(e.target)) return;
    if (e.target.closest('.te-rcq-qv-x')) { dlg.close(); return; }
    var t = e.target.closest('[data-qv-img]');
    if (t) { imgIdx = +t.getAttribute('data-qv-img'); render(); return; }
    var o = e.target.closest('[data-qv-opt]');
    if (o) {
      sel[+o.getAttribute('data-qv-opt')] = o.getAttribute('data-qv-val');
      // Photo follows the options chosen so far (e.g. a colour before a size)
      var v = variant() || product.variants.find(function (x) {
        return x.featured_image && x.options.every(function (y, k) { return sel[k] == null || y === sel[k]; });
      });
      if (v && v.featured_image && product.images) {
        var k = product.images.map(noProto).indexOf(noProto(v.featured_image.src));
        if (k > -1) imgIdx = k;
      }
      render(); return;
    }
    var add = e.target.closest('.te-rcq-qv-add');
    if (add && !add.disabled) {
      var v2 = variant(), msg = dlg.querySelector('.te-rcq-qv-msg');
      add.disabled = true; add.textContent = 'Adding…';
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: v2.id, quantity: 1 }] }) })
        .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
        .then(function () {
          add.textContent = 'Added'; msg.innerHTML = 'Added to your cart. <a href="/cart">View cart</a>';
          ['cart:refresh', 'cart:updated', 'cart:change'].forEach(function (ev) {
            document.dispatchEvent(new CustomEvent(ev, { bubbles: true }));
          });
          // Header count: update the usual count elements directly from /cart.js
          fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
            document.querySelectorAll('[data-cart-count], .cart-count, .cart-count-bubble span[aria-hidden="true"], .js-cart-count, .header__cart-count').forEach(function (n) { n.textContent = c.item_count; });
          }).catch(function () {});
          setTimeout(function () { add.disabled = false; add.textContent = 'Add to cart'; }, 1800);
        })
        .catch(function (err) { add.disabled = false; add.textContent = 'Add to cart'; msg.textContent = (err && err.description) || 'Couldn’t add this size. Please try again.'; });
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["te-rcq-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__gsTeClCountdownBound) return;
  window.__gsTeClCountdownBound = true;

  function pad(n) { return String(n).padStart(2, '0'); }

  function tickOne(el) {
    // Epoch seconds from Liquid parse everywhere; the ISO string is a fallback
    var ts = parseInt(el.getAttribute('data-end-ts') || '', 10);
    var end = ts ? ts * 1000 : Date.parse(el.getAttribute('data-end') || '');
    if (!end || isNaN(end)) {
      el.hidden = true;
      return;
    }
    var d = end - Date.now();
    if (d <= 0) {
      el.hidden = true;
      return;
    }
    el.hidden = false;
    var days = Math.floor(d / 86400000);
    var hours = Math.floor(d / 3600000) % 24;
    var mins = Math.floor(d / 60000) % 60;
    var secs = Math.floor(d / 1000) % 60;
    var map = { days: days, hours: hours, mins: mins, secs: secs };
    el.querySelectorAll('[data-unit]').forEach(function (node) {
      var key = node.getAttribute('data-unit');
      if (map[key] != null) node.textContent = pad(map[key]);
    });
  }

  function tickAll() {
    document.querySelectorAll('[data-gs-te-cl-countdown]').forEach(tickOne);
  }

  tickAll();
  setInterval(tickAll, 1000);
}());

(function () {
  if (window.__teRcqHeroDescBound) return;
  window.__teRcqHeroDescBound = true;

  // Show "Read more" only when the clamped description actually overflows
  function measure() {
    document.querySelectorAll('[data-te-rcq-hero-desc]').forEach(function (wrap) {
      if (wrap.classList.contains('is-open')) return;
      var text = wrap.querySelector('.te-rcq-hero-desc-text');
      var btn = wrap.querySelector('.te-rcq-hero-more');
      if (text && btn) btn.hidden = text.scrollHeight <= text.clientHeight + 2;
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.te-rcq-hero-more');
    if (!btn) return;
    var wrap = btn.closest('[data-te-rcq-hero-desc]');
    if (!wrap) return;
    var open = wrap.classList.toggle('is-open');
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    btn.querySelector('[data-more]').hidden = open;
    btn.querySelector('[data-less]').hidden = !open;
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', measure);
  else measure();
  window.addEventListener('resize', measure);
  document.addEventListener('shopify:section:load', measure);
}());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["te-rcq-pros"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.getElementById('te-rcq-pros-{{ section.id }}');
  if (!root || !window.IntersectionObserver) return;
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.style.opacity = '1';
        entry.target.style.transform = 'translateY(0)';
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.08 });
  root.querySelectorAll('.te-rcq-pro-card').forEach(function (el) {
    el.style.opacity = '0';
    el.style.transform = 'translateY(16px)';
    el.style.transition = 'opacity .35s ease, transform .35s ease';
    observer.observe(el);
  });
}());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["te-rcq-titles"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = document.getElementById('te-rcq-tiles-{{ section.id }}');
  if (!root || !window.IntersectionObserver) return;
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.style.opacity = '1';
        entry.target.style.transform = 'translateY(0)';
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.08 });
  root.querySelectorAll('.te-rcq-tile').forEach(function (el) {
    el.style.opacity = '0';
    el.style.transform = 'translateY(16px)';
    el.style.transition = 'opacity .35s ease, transform .35s ease';
    observer.observe(el);
  });
}());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["te-shoes-lp"] && !Shopify.designMode) return;
  try {
    
(function(){
  var roots = document.querySelectorAll('.te-shoe-tailored');
  if (!roots.length) return;
  var INITIAL_VISIBLE = 12;

  roots.forEach(function(root){
    var grid     = root.querySelector('[data-tailored-grid]');
    var tabs     = root.querySelectorAll('.te-shoe-tailored-brand');
    var titleEl  = root.querySelector('[data-tailored-title]');
    var viewallEl = root.querySelector('[data-tailored-viewall]');
    if (!grid || !tabs.length) return;
    var BRAND_VISIBLE = parseInt(grid.getAttribute('data-brand-visible'), 10) || 24;
    var cards = grid.querySelectorAll('.te-shoe-tailored-card');

    function syncMeta(label, href){
      if (titleEl) titleEl.textContent = label || (titleEl.getAttribute('data-default') || '');
      if (viewallEl) {
        viewallEl.textContent = href ? 'View All ' + label : (viewallEl.getAttribute('data-default-text') || 'View all');
        viewallEl.href = href || viewallEl.getAttribute('data-default-href') || '#';
      }
    }
    function applyAll(){
      var n = 0;
      cards.forEach(function(c){
        if (c.hasAttribute('data-brand-only')) {
          c.setAttribute('hidden', '');
        } else {
          if (n < INITIAL_VISIBLE) c.removeAttribute('hidden');
          else c.setAttribute('hidden', '');
          n++;
        }
      });
      syncMeta(null, null);
    }
    function applyBrand(brand, label, collUrl){
      var n = 0;
      cards.forEach(function(c){
        var match = (c.getAttribute('data-brand') || '').toLowerCase() === brand;
        if (match) {
          if (n < BRAND_VISIBLE) c.removeAttribute('hidden');
          else c.setAttribute('hidden', '');
          n++;
        } else {
          c.setAttribute('hidden', '');
        }
      });
      syncMeta(label + ' Shoes', collUrl);
    }
    applyAll();

    tabs.forEach(function(tab){
      tab.addEventListener('click', function(){
        tabs.forEach(function(t){ t.classList.remove('is-active'); t.setAttribute('aria-selected', 'false'); });
        tab.classList.add('is-active');
        tab.setAttribute('aria-selected', 'true');
        var brand    = (tab.getAttribute('data-brand') || '').toLowerCase().trim();
        var label    = tab.getAttribute('data-brand-label') || brand;
        var collUrl  = tab.getAttribute('data-brand-url') || '';
        if (!brand) applyAll();
        else applyBrand(brand, label, collUrl);
      });
    });

    // Brand strip slider — arrows + fade hints based on overflow + scroll position
    var outer = root.querySelector('[data-brands-outer]');
    var wrap  = root.querySelector('[data-brands-wrap]');
    var prev  = root.querySelector('[data-brands-prev]');
    var next  = root.querySelector('[data-brands-next]');
    if (outer && wrap) {
      function update(){
        var max = wrap.scrollWidth - wrap.clientWidth;
        var x = wrap.scrollLeft;
        var canLeft  = x > 2;
        var canRight = x < max - 2;
        outer.setAttribute('data-can-scroll-left',  canLeft  ? 'true' : 'false');
        outer.setAttribute('data-can-scroll-right', canRight ? 'true' : 'false');
        if (prev) prev.hidden = !canLeft;
        if (next) next.hidden = !canRight;
      }
      function step(){
        // Scroll by ~3 brand cards (88px + 10px gap) on each click
        return Math.max(180, Math.min(wrap.clientWidth * 0.7, 320));
      }
      if (prev) prev.addEventListener('click', function(){ wrap.scrollBy({ left: -step(), behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function(){ wrap.scrollBy({ left:  step(), behavior: 'smooth' }); });
      wrap.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
      // Run on next frame so logos finish loading and widths settle
      requestAnimationFrame(update);
      setTimeout(update, 400);
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["te-tcq-brands"] && !Shopify.designMode) return;
  try {
    
/* Scroll arrows for horizontal rows marked data-te-rail (brand strip, type
   pills). Shared by both sections and bound once. Only the arrows that lead
   somewhere show: "next" while there's more to the right, "prev" once
   scrolled; none at all when everything fits. */
(function () {
  if (window.__teRail) return;
  window.__teRail = true;
  function bind(rail) {
    if (rail.__teRail) return;
    var scroll = rail.querySelector('[data-te-rail-scroll]');
    var nav = rail.querySelector('.te-rcq-rail-nav');
    var prev = rail.querySelector('[data-te-rail-prev]');
    var next = rail.querySelector('[data-te-rail-next]');
    if (!scroll || !nav || !prev || !next) return;
    rail.__teRail = true;
    function update() {
      var atStart = scroll.scrollLeft <= 2;
      var atEnd = scroll.scrollLeft + scroll.clientWidth >= scroll.scrollWidth - 2;
      prev.hidden = atStart;
      next.hidden = atEnd;
      nav.hidden = atStart && atEnd;
    }
    function step() { return Math.max(160, Math.round(scroll.clientWidth * 0.7)); }
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var how = reduce ? 'auto' : 'smooth';
    prev.addEventListener('click', function () { scroll.scrollBy({ left: -step(), behavior: how }); });
    next.addEventListener('click', function () { scroll.scrollBy({ left: step(), behavior: how }); });
    scroll.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    window.addEventListener('load', update);
    update();
  }
  function scan() { document.querySelectorAll('[data-te-rail]').forEach(bind); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', scan); } else { scan(); }
  document.addEventListener('shopify:section:load', scan);
}());
/* Drag-to-scroll for horizontal rows marked data-te-drag-scroll. Touch
   already scrolls natively; this adds mouse dragging, which the theme
   editor's mobile preview and desktop mice otherwise can't do. Shared by the
   brand strip and type pills and bound once, whichever section loads first. */
(function () {
  if (window.__teDragScroll) return;
  window.__teDragScroll = true;
  function bind(el) {
    if (el.__teDrag) return;
    el.__teDrag = true;
    var down = false, moved = false, startX = 0, startLeft = 0;
    el.addEventListener('dragstart', function (e) { e.preventDefault(); });
    el.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      down = true; moved = false; startX = e.clientX; startLeft = el.scrollLeft;
    });
    window.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      if (!moved && Math.abs(dx) > 5) { moved = true; el.classList.add('is-dragging'); }
      if (moved) el.scrollLeft = startLeft - dx;
    });
    window.addEventListener('pointerup', function () {
      if (!down) return;
      down = false;
      el.classList.remove('is-dragging');
    });
    /* A drag must not also count as a click on the pill or logo under it. */
    el.addEventListener('click', function (e) {
      if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; }
    }, true);
  }
  function scan() { document.querySelectorAll('[data-te-drag-scroll]').forEach(bind); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', scan); } else { scan(); }
  document.addEventListener('shopify:section:load', scan);
}());

  } catch(e) { console.error(e); }
})();
})();
